import React from 'react'
import SchemaForm from 'components/forms/SchemaForm'
import { connect } from 'react-redux'
import { countriesOptions } from 'lists/countries'
import contactSchema from 'forms/contactSchema'

class ContactForm extends React.Component {
  render () {
    return (
      <SchemaForm entityName='contact' {...this.props} />
      )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    uiSchema: contactSchema(state, ownProps)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('countries'))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
